// 1 APT = 10^8 octas (similar to 1 BTC = 10^8 satoshis)
export const OCTAS_PER_APT = 1e8;
